"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var kendo_react_grid_1 = require("@progress/kendo-react-grid");
var TableLoadingPanel_1 = require("./TableLoadingPanel");
function isColumnElement(element) {
    if (!react_1.default.isValidElement(element)) {
        return false;
    }
    var elementType = element.type;
    return (elementType === kendo_react_grid_1.GridColumn ||
        elementType.originalType === kendo_react_grid_1.GridColumn);
}
function traverse(children, callback) {
    return react_1.default.Children.map(children, function (child) {
        if (!isColumnElement(child)) {
            return child;
        }
        return child.props.children
            ? react_1.cloneElement(callback(child), {
                children: traverse(child.props.children, callback),
            })
            : callback(child);
    });
}
exports.Table = react_1.forwardRef(function (_a, ref) {
    var loading = _a.loading, _b = _a.striped, striped = _b === void 0 ? true : _b, borders = _a.borders, originRowRender = _a.rowRender, className = _a.className, originChildren = _a.children, props = __rest(_a, ["loading", "striped", "borders", "rowRender", "className", "children"]);
    var _c = react_1.default.useState(), container = _c[0], setContainer = _c[1];
    var handleRef = react_1.default.useCallback(function (loader) {
        var _a;
        var container = (_a = loader === null || loader === void 0 ? void 0 : loader.previousElementSibling) !== null && _a !== void 0 ? _a : null;
        setContainer(container !== null && container !== void 0 ? container : undefined);
        if (ref) {
            if (typeof ref === 'function') {
                ref(container);
            }
            else {
                Object.assign(ref, {
                    current: container,
                });
            }
        }
    }, [ref]);
    var rowRender = react_1.default.useCallback(function (originRow, rowProps) {
        var overrides = {};
        if (props.detail && rowProps.rowType === 'groupHeader') {
            overrides.children = react_1.default.Children.map(originRow.props.children, function (child) {
                return react_1.cloneElement(child, {
                    columnsCount: child.props.columnsCount - 1,
                });
            });
        }
        var row = Object.keys(overrides).length > 0
            ? react_1.cloneElement(originRow, overrides)
            : originRow;
        return originRowRender ? originRowRender(row, rowProps) : row;
    }, [originRowRender, props.detail]);
    var children = react_1.default.useMemo(function () {
        return traverse(originChildren, function (column) {
            var _a = column.props, field = _a.field, headerClassName = _a.headerClassName, groupable = _a.groupable;
            var isFiltersActive = field && kendo_react_grid_1.GridColumnMenuFilter.active(field, props.filter);
            var isGroupable = groupable &&
                !(props.group || []).find(function (g) { return g.field === field; });
            return react_1.cloneElement(column, {
                groupable: isGroupable,
                headerClassName: classnames_1.default(headerClassName, isFiltersActive && 'Table__Filter--active'),
            });
        });
    }, [originChildren, props.filter, props.group]);
    var _d = borders || {}, verticalBorders = _d.vertical, _e = _d.horizontal, horizontalBorders = _e === void 0 ? !striped : _e;
    var TableClasses = classnames_1.default('Table', striped && 'Table--striped', typeof verticalBorders === 'boolean'
        ? verticalBorders && 'Table--vertical-borders'
        : 'Table--locked-borders', horizontalBorders && 'Table--horizontal-borders', props.detail && 'Table--master-detail', props.sortable && 'Table--sortable', className);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(kendo_react_grid_1.Grid, __assign({}, props, { rowRender: rowRender, className: TableClasses }), children),
        react_1.default.createElement("div", { ref: handleRef }, loading && react_1.default.createElement(TableLoadingPanel_1.TableLoadingPanel, { portal: container }))));
});
exports.Table.displayName = 'KendoReactGrid';
//# sourceMappingURL=Table.js.map